import { faArrowUp, faCheck, faPlay, faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setErrorMessage } from "../../../shared/helpers/functionalities.js";
import { API_FINANZAS } from "../../../shared/services/finanzas.js";
import moment from "moment";

const PLATAFORMAS = [
    { id: 3,  name: 'Recambiofacil', abbr: 'Rf', css: { background: '#ffedd5', color: '#9a3412' },
        needsCsv: true, needsPdf: false, needsFecha: false, buttonLabel: 'Verificar pagos', buttonIcon: faCheck, disabled: false },
    { id: 4,  name: 'Ebay', abbr: 'Eb', css: { background: '#dbeafe', color: '#1e40af' },
        needsCsv: false, needsPdf: false, needsFecha: false, buttonLabel: 'Procesar payout', buttonIcon: faPlay, disabled: true },
    { id: 13, name: 'Ovoko', abbr: 'Ov', css: { background: '#fef9c3', color: '#854d0e' },
        needsCsv: true, needsPdf: false, needsFecha: true, buttonLabel: 'Procesar', buttonIcon: faArrowUp , disabled: false},
    { id: 14, name: 'Opisto', abbr: 'Op', css: { background: '#dcfce7', color: '#166534' },
        needsCsv: true, needsPdf: false, needsFecha: true, buttonLabel: 'Procesar', buttonIcon: faArrowUp , disabled: false},
    { id: 17, name: 'Wallapop', abbr: 'Wp', css: { background: '#cffafe', color: '#155e75' },
        needsCsv: true, needsPdf: false, needsFecha: false, buttonLabel: 'Sincronizar', buttonIcon: faSync, disabled: false },
    { id: 18, name: 'Used World Parts', abbr: 'Uwp', css: { background: '#f3e8ff', color: '#6b21a8' },
        needsCsv: false, needsPdf: true, needsFecha: true, buttonLabel: 'Verificar pago', buttonIcon: faCheck, disabled: false },
    { id: 20, name: 'Bparts', abbr: 'Bp', css: { background: '#1a1a1a', color: '#f97316' },
        needsCsv: false, needsPdf: true, needsFecha: true, buttonLabel: 'Verificar pago', buttonIcon: faCheck, disabled: false },
    { id: 22, name: 'Neryus', abbr: 'Ne', css: { background: '#fce7f3', color: '#9d174d' },
        needsCsv: false, needsPdf: true, needsFecha: true, buttonLabel: 'Verificar pago', buttonIcon: faCheck, disabled: false },
]

const API_BY_ID = {
    3:  (csv, _, __) => { const f = new FormData(); f.append('file', csv); return API_FINANZAS.conciliarRF(f) },
    4:  (_, __, ___, ebayId) => API_FINANZAS.conciliarEbay(ebayId),
    13: (csv, _, fecha) => { const f = new FormData(); f.append('file', csv); f.append('fecha_cobro', fecha); return API_FINANZAS.conciliarOvoko(f) },
    14: (csv, _, fecha) => { const f = new FormData(); f.append('file', csv); f.append('fecha_cobro', fecha); return API_FINANZAS.conciliarOpisto(f) },
    17: (csv) => { const f = new FormData(); f.append('file', csv); return API_FINANZAS.conciliarWallapop(f) },
    18: (_, pdf, fecha) => { const f = new FormData(); f.append('file', pdf); f.append('fecha_cobro', fecha); return API_FINANZAS.conciliarUsedWorldParts(f) },
    20: (_, pdf, fecha) => { const f = new FormData(); f.append('file', pdf); f.append('fecha_cobro', fecha); return API_FINANZAS.conciliarBparts(f) },
    22: (_, pdf, fecha) => { const f = new FormData(); f.append('file', pdf); f.append('fecha_cobro', fecha); return API_FINANZAS.conciliarNeryus(f) },
}

export default function Conciliaciones() {
    const dispatch = useDispatch();
    const [plataformasInfo, setPlataformasInfo] = useState(PLATAFORMAS);
    const [platInputs, setPlatInputs] = useState({})

    useEffect(() => {
        fetchConciliaciones();
    }, []);

    const getTableHeight = (plat) => {
        let height = 250
        if (plat.needsCsv) height -= 60
        if (plat.needsFecha) height -= 60
        if (plat.id === 4) height -= 60 // ebay payout
        return Math.max(height, 80) // mínimo 80px
    }

    const fetchConciliaciones = async() => {
        dispatch({ type: 'loading/set', payload: true })
        const response = await API_FINANZAS.getConciliacionesStatus()
        .catch(error => {
            toast.error(setErrorMessage(error))
            dispatch({ type: 'loading/set', payload: false })
        })

        const data = await response.data;
        const updated = PLATAFORMAS.map(p => {
            const count = data.find(d => d.plataforma_id === p.id)?.count ?? 0
            const pending = data.find(d => d.plataforma_id === p.id)?.pending ?? 0

            return {...p, count, pending}
        })
        setPlataformasInfo(updated);
        dispatch({ type: 'loading/set', payload: false })
    }

    const updateInput = (platId, key, value) => 
        setPlatInputs(prev => ({ ...prev, [platId]: { ...prev[platId], [key]: value } }))

    const handleConciliar = async (platFormId) => {
        const inputs = platInputs[platFormId] ?? {}
        const { csvFile, pdfFile, fechaCobro, ebayPayoutId } = inputs
        const plat = PLATAFORMAS.find(p => p.id === platFormId)

        if (platFormId === 4 && !ebayPayoutId) return toast.warning('Debes introducir un PAYOUT ID')
        if (plat.needsCsv && !csvFile) return toast.warning('Debes adjuntar un fichero .csv!')
        if (plat.needsPdf && !pdfFile) return toast.warning('Debes adjuntar un fichero .pdf!')
        if (plat.needsFecha && !fechaCobro) return toast.warning('Debes introducir una fecha de cobro!')

        dispatch({ type: 'loading/set', payload: true })
        
        try {
            const response = await API_BY_ID[platFormId](csvFile, pdfFile, fechaCobro, ebayPayoutId)
            if (response?.success) {
                toast.success(response.message)
                fetchConciliaciones()
            }
        } catch (error) {
            toast.error(setErrorMessage(error))
        } finally {
            dispatch({ type: 'loading/set', payload: false })
        }
    }

    return (
        <div className="container-fluid py-4">
            <p className="text-uppercase text-muted small fw-semibold mb-3">Configurar por plataforma</p>
            
            <div className="row g-3">
                {plataformasInfo.map(plat => (
                    <div key={plat.id} className="col-12 col-md-6 col-lg-4">
                        <div className="card border rounded-3 d-flex flex-column p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <div className="d-flex align-items-center gap-2">
                                    <div className="rounded-2 d-flex align-items-center justify-content-center fw-bold"
                                        style={{ width: 40, height: 40, fontSize: 13, ...plat.css }}>
                                        {plat.abbr}
                                    </div>
                                    <p className="mb-0 fw-semibold">{plat.name}</p>
                                </div>
                                {plat.count === 0
                                    ? <span className="text-green">●</span>
                                    : <span className="bg-danger px-3 py-2 rounded-pill text-white fw-bold d-inline-flex align-items-center justify-content-center"
                                        style={{ width: 22, height: 22, fontSize: 11 }}>
                                        {plat.count}
                                    </span>
                                }
                            </div>

                            <div className="flex-grow-1 d-flex flex-column gap-2">
                                {plat.id === 4 && (
                                    <>
                                        <p className="text-uppercase text-muted small fw-semibold mb-0">Payout ID</p>
                                        <input className="form-control" placeholder="ej. PAYOUTID123456"
                                            value={platInputs[plat.id]?.ebayPayoutId ?? ''}
                                            onChange={e => updateInput(plat.id, 'ebayPayoutId', e.target.value)} />
                                    </>
                                )}
                                {plat.needsCsv && (
                                    <>
                                        <p className="text-uppercase text-muted small fw-semibold mb-0">Archivo CSV de orders</p>
                                        <input type="file" className="form-control" accept=".csv"
                                            onChange={e => updateInput(plat.id, 'csvFile', e.target.files[0])} />
                                    </>
                                )}

                                {plat.needsPdf && (
                                    <>
                                        <p className="text-uppercase text-muted small fw-semibold mb-0">Archivo PDF del banco</p>
                                        <input type="file" className="form-control" accept=".pdf"
                                            onChange={e => updateInput(plat.id, 'pdfFile', e.target.files[0])} />
                                    </>
                                )}
                                {plat.needsFecha && (
                                    <>
                                        <p className="text-uppercase text-muted small fw-semibold mb-0">Fecha de cobro</p>
                                        <input type="date" className="form-control"
                                            value={platInputs[plat.id]?.fechaCobro ?? ''}
                                            onChange={e => updateInput(plat.id, 'fechaCobro', e.target.value)} />
                                    </>
                                )}

                                {plat.pending?.length > 0 && (
                                    <div className='mt-2 flex-grow-1'>
                                        <p className="text-uppercase text-muted small fw-semibold mb-1">
                                            Pendientes ({plat.pending.length})
                                        </p>
                                        <div style={{ maxHeight: getTableHeight(plat), overflowY: 'auto' }} className='border rounded'>
                                            <table className='table table-sm mb-0'>
                                                <thead className='sticky-top bg-white'>
                                                    <tr>
                                                        <th className='small'>Pedido</th>
                                                        <th className='text-center small'>Fecha</th>
                                                        <th className='text-center small'>Factura</th>
                                                        <th className='text-center small'>Total IVA</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {plat.pending.map((p, i) => (
                                                        <tr key={i}>
                                                            <td className='small'>{p.codigo_pedido}</td>
                                                            <td className='text-center small'>{moment(p.fecha).format('DD-MM-YYYY')}</td>
                                                            <td className='text-center small'>{p.numero_factura ?? '-'}</td>
                                                            <td className='text-center small'>{p.total_iva}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="w-100 small mt-2">
                                            <p className="text-end">
                                                Total: &nbsp;
                                                <b>
                                                    {parseFloat(plat.pending.reduce((acc, cur) => acc + cur.total_iva, 0)).toFixed(2)}€
                                                </b>
                                            </p>
                                        </div>
                                    </div>
                                )}

                                <button className="btn btn-outline-secondary w-100 mt-auto"
                                    disabled={plat.disabled}
                                    onClick={() => handleConciliar(plat.id)}>
                                    <FontAwesomeIcon icon={plat.buttonIcon} size="2" /> {plat.buttonLabel}
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}